import { render } from "./layout.vue?vue&type=template&id=953c2fd8&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=953c2fd8&scoped=true&lang=css"
import "./layout.vue?vue&type=style&index=1&id=953c2fd8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953c2fd8"]])

export default __exports__